import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL;
const API2 = process.env.REACT_APP_API_URL2;

function Setting() {
  const [isOpen, setIsOpen] = useState(false);

  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");

  const [logo, setLogo] = useState(null);
  const [favicon, setFavicon] = useState(null);

  const [logoPreview, setLogoPreview] = useState(null);
  const [faviconPreview, setFaviconPreview] = useState(null);

  const [companyId, setCompanyId] = useState(null);

  useEffect(() => {
    document.title = "Company Settings | Admin Panel";
    fetchCompany();
  }, []);

  // ✅ GET COMPANY
  const fetchCompany = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API}/company`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data) {
        const data = res.data;

        setCompanyId(data.id || null);
        setCompanyName(data.company_name || "");
        setEmail(data.email || "");
        setPhone(data.phone || "");
        setAddress(data.address || "");

        // ✅ image preview from backend
        setLogoPreview(data.logo ? `${API2}/storage/${data.logo}` : null);
        setFaviconPreview(
          data.favicon ? `${API2}/storage/${data.favicon}` : null
        );
      }
    } catch (err) {
      toast.error("Failed to load company data");
    }
  };

  // ✅ SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("company_name", companyName);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("address", address);

      if (logo) formData.append("logo", logo);
      if (favicon) formData.append("favicon", favicon);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      // ✅ UPDATE
      if (companyId) {
        formData.append("_method", "PUT");

        await axios.post(`${API}/company/${companyId}`, formData, config);

        toast.success("Company updated successfully 🚀");
      } 
      // ✅ CREATE
      else {
        const res = await axios.post(`${API}/company`, formData, config);
        setCompanyId(res.data.id);

        toast.success("Company created successfully 🎉");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong ❌");
    }
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">
      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />

      <div className="flex-1 flex flex-col">
        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6 flex justify-center">
          <div className="w-full max-w-3xl">

            {/* FORM */}
            <form
              onSubmit={handleSubmit}
              className="bg-white rounded-2xl shadow-lg p-6 space-y-5"
            >

              {/* GRID INPUTS */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                {/* COMPANY NAME */}
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Company Name
                  </label>
                  <input
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="w-full mt-1 p-3 border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="Enter company name"
                  />
                </div>

                {/* EMAIL */}
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Email Address
                  </label>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mt-1 p-3 border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="Enter email"
                  />
                </div>

                {/* PHONE */}
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Contact Number
                  </label>
                  <input
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="w-full mt-1 p-3 border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="Enter phone number"
                  />
                </div>

                {/* ADDRESS */}
                <div className="md:col-span-2">
                  <label className="text-sm font-medium text-gray-600">
                    Address
                  </label>
                  <textarea
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="w-full mt-1 p-3 border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none resize-none h-28"
                    placeholder="Enter company address"
                  />
                </div>
              </div>

              {/* FILE UPLOADS */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 hidden">

                {/* LOGO */}
                <div className="p-4 border rounded-xl bg-gray-50">

                  <label className="text-sm font-medium text-gray-600">
                    Company Logo
                  </label>

                  {/* PREVIEW */}
                  {logoPreview && (
                    <div className="mb-2">
                      <img
                        src={logoPreview}
                        alt="Logo Preview"
                        className="h-16 w-16 object-cover rounded-lg border"
                      />
                    </div>
                  )}

                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      setLogo(file);
                      if (file) {
                        setLogoPreview(URL.createObjectURL(file));
                      }
                    }}
                    className="w-full mt-2"
                  />

                  <p className="text-xs text-gray-400 mt-1">
                    JPG, JPEG, PNG only
                  </p>
                </div>

                {/* FAVICON */}
                <div className="p-4 border rounded-xl bg-gray-50">

                  <label className="text-sm font-medium text-gray-600">
                    Favicon
                  </label>

                  {/* PREVIEW */}
                  {faviconPreview && (
                    <div className="mb-2">
                      <img
                        src={faviconPreview}
                        alt="Favicon Preview"
                        className="h-12 w-12 object-cover rounded border"
                      />
                    </div>
                  )}

                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      setFavicon(file);
                      if (file) {
                        setFaviconPreview(URL.createObjectURL(file));
                      }
                    }}
                    className="w-full mt-2"
                  />

                  <p className="text-xs text-gray-400 mt-1">
                    JPG, JPEG, PNG only
                  </p>
                </div>
              </div>

              {/* BUTTON */}
              <button
                type="submit"
                className="w-full md:w-auto px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl shadow-md hover:scale-[1.02] transition font-semibold"
              >
                {companyId ? "Update Company" : "Create Company"}
              </button>

            </form>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Setting;